import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

// Integrações via API (v1) de um TP: aba Integrações do cadastro do TP

export async function getTpIntegrations(tp_id) {
  try {
    const response = await authHttp().get(routes.urlTpIntegrations(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function createTpIntegration(tp_id, partner, config) {
  try {
    const response = await authHttp().post(routes.urlTpIntegrations(tp_id), { partner, config })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// changes: { config?, active? }
export async function updateTpIntegration(tp_id, id, changes) {
  try {
    const response = await authHttp().put(routes.urlTpIntegration(tp_id, id), changes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Devolve { token, credential }: o token completo só existe nesta resposta
export async function createIntegrationCredential(tp_id, id, description) {
  try {
    const response = await authHttp().post(routes.urlTpIntegrationCredentials(tp_id, id), {
      description,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function revokeIntegrationCredential(tp_id, id, credential_id) {
  try {
    const response = await authHttp().put(
      routes.urlTpIntegrationCredentialRevoke(tp_id, id, credential_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
